import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { fish_image } from "../../constant/urls";
import { useAppContext } from "../../context/state";
import { addCommas, useRequest } from "../../utils";
import moment from "jalali-moment";

const formatDuration = (value) => {
  const seconds = Math.max(0, Math.floor(Number(value) || 0));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`
    : `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
};

//locall

const UserDetails = (props) => {
  //   const data = props.location.query.data;
  //   const [
  //     verify_cart_fish_error,
  //     verify_cart_fish_loading,
  //     verify_cart_fish_data,
  //     verify_cart_fish_function,
  //   ] = useRequest({
  //     method: "post",
  //     url: "/verify_cart_fish",
  //     body: {
  //       payment_id: props.match.params.id,
  //     },
  //     isFunction: true,
  //   });
  let history = useHistory();

  const [
    get_user_details_error,
    get_user_details_loading,
    get_user_details_data,
    get_user_details_function,
    clear_get_user_details,
  ] = useRequest({
    method: "post",
    url: "/get_user_details",
    body: {
      user_id: props.match.params.id,
    },
  });
  const [
    delete_all_products_error,
    delete_all_products_loading,
    delete_all_products_data,
    delete_all_products_function,
  ] = useRequest({
    method: "post",
    url: "/delete_all_products",
    body: {
      user_id: props.match.params.id,
    },
    isFunction: true,
  });

  const [
    delete_payment_user_error,
    delete_payment_user_loading,
    delete_payment_user_data,
    delete_payment_user_function,
    clear_delete_payment_user,
  ] = useRequest({
    method: "post",
    url: "/delete_payment_user",
    isFunction: true,
  });

  const [
    delete_product_user_error,
    delete_product_user_loading,
    delete_product_user_data,
    delete_product_user_function,
    clear_delete_product_user,
  ] = useRequest({
    method: "post",
    url: "/delete_product_user",
    isFunction: true,
  });

  const data = get_user_details_data?.data;

  return !data ? null : (
    <>
      <div class="content-header row"></div>
      <div class="content-body">
        <section className="card card-body">
          <div class="content-body">
            {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
            <div style={{ marginBottom: "10px" }}>
              نام کاربر : {data.user_data.name}
            </div>
            <button
              type="button"
              class="btn btn-warning round mr-1 mb-1 btn-sm"
              style={{ width: "fit-content" }}
              onClick={() =>
                delete_all_products_function()
                  .then(() => {
                    utils.showAlert(
                      "حذف همه ی محصولات با موفقیت انجام شد",
                      "success"
                    );
                    get_user_details_function();
                  })
                  .catch(() =>
                    utils.showAlert(
                      "مشکلی در انجام عملیات به وجود آمد",
                      "error"
                    )
                  )
              }
            >
              حذف همه محصولات
            </button>
            <div style={{ marginBottom: "10px" }}>
              {/* نام کاربر : {data.user_data.name} */}
            </div>
            <button
              onClick={() =>
                history.push(
                  "/dashboard/userDetails/" +
                    props.match.params.id +
                    "/addPaymentToUser"
                )
              }
              style={{ marginTop: "1rem" }}
              type="button"
              class="btn btn-success mr-1 mb-1 "
            >
              افزودن تراکنش جدید
            </button>
            <h6>تراکنش های کاربر :</h6>
            {data ? (
              data.payment_data ? (
                <Table
                  Thead={() => (
                    <tr>
                      <th className="table--title">شماره</th>
                      <th className="table--title">مبلغ</th>
                      <th className="table--title">نوع پرداخت</th>
                      <th className="table--title">توضیح پرداخت</th>
                      <th className="table--title">وضعیت</th>
                      <th className="table--title">تاریخ ایجاد تراکنش</th>

                      {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                      <th className="table--title">عملیات</th>
                    </tr>
                  )}
                  Tbody={() =>
                    data.payment_data.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{addCommas(item._price) + "تومان"}</td>
                        <td>
                          {item._type === "online" ? "آنلاین" : "کارت به کارت"}
                        </td>
                        <td>
                          {item._des === "initial_payment"
                            ? "پرداخت اولیه"
                            : null}
                          {item._des === "term_support_payment"
                            ? "پرداخت پشتیبانی ترم"
                            : null}
                          {item._des === "term_payment" ? "پرداخت ترم" : null}
                          {item._des === "manual_payment"
                            ? "پرداخت دستی"
                            : null}
                        </td>
                        <td>
                          {item._status === "paid"
                            ? "موفق"
                            : item._status === "waiting"
                            ? "در انتظار تایید"
                            : "ناموفق"}
                        </td>
                        <td style={{ direction: "ltr" }}>
                          {moment(item.creation_date)
                            .locale("fa")
                            .format("YYYY/MM/DD, h:mm:ss a")}
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/dashboard/paymentDetails/" + item._id,
                            }}
                          >
                            <button
                              type="button"
                              class="btn btn-primary round mr-1 mb-1 btn-sm"
                            >
                              جزییات
                            </button>
                          </Link>
                          <button
                            onClick={async () => {
                              // await utils.showAlert(
                              //   "در حال حذف محصول",
                              //   "warning"
                              // );
                              await clear_get_user_details();
                              const f = async () => {
                                await delete_payment_user_function({
                                  user_id: props.match.params.id,
                                  payment_id: item._id,
                                }).then(() => null);
                                await get_user_details_function().then(
                                  () => null
                                );
                                await utils.showAlert(
                                  "تراکنش با موفقیت حذف شد",
                                  "success"
                                );
                                // await history.go(0);
                              };
                              await f();
                            }}
                            type="button"
                            class="btn btn-danger round mr-1 mb-1 btn-sm"
                          >
                            حذف
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                />
              ) : null
            ) : null}
            <button
              onClick={() =>
                history.push(
                  "/dashboard/userDetails/" +
                    props.match.params.id +
                    "/addProductToUser"
                )
              }
              style={{ marginTop: "1rem" }}
              type="button"
              class="btn btn-success mr-1 mb-1 "
            >
              افزودن محصول جدید
            </button>
            <h6>محصولات کاربر :</h6>
            {data ? (
              data.user_products_data ? (
                <Table
                  Thead={() => (
                    <tr>
                      <th className="table--title">شماره</th>
                      <th className="table--title">عنوان</th>
                      <th className="table--title">نوع</th>
                      <th className="table--title">ترم ها</th>
                      <th className="table--title">پشتیبانی ها</th>
                      <th className="table--title">عملیات</th>
                    </tr>
                  )}
                  Tbody={() =>
                    data.user_products_data.map((item, index) => (
                      <tr>
                        {item.product_id ? (
                          <>
                            <td>{index + 1}</td>
                            <td>
                              {item.product_id.title} - {item.instagram_id}
                            </td>
                            <td>{item.product_id.type}</td>
                            <td>
                              {item.payment
                                ? "همه"
                                : item.product_id.terms
                                    .filter((i) =>
                                      item.term_ids?.find(
                                        (_i) =>
                                          String(i._id) ===
                                            String(_i.term_id) && _i.payment
                                      )
                                    )
                                    .map((i) => <div>{i.title + "-"}</div>)}
                            </td>
                            <td>
                              {item.support_all_payment
                                ? "همه"
                                : item.product_id.terms.filter((i) =>
                                    item.term_ids?.find(
                                      (_i) =>
                                        String(i._id) === String(_i.term_id) &&
                                        _i.support_payment
                                    )
                                  ).length > 0
                                ? item.product_id.terms
                                    .filter((i) =>
                                      item.term_ids?.find(
                                        (_i) =>
                                          String(i._id) ===
                                            String(_i.term_id) &&
                                          _i.support_payment
                                      )
                                    )
                                    .map((i) => <div>{i.title + "-"}</div>)
                                : "بدون پشتیبانی"}
                            </td>
                            <td>
                              <Link
                                to={{
                                  pathname:
                                    "/dashboard/userDetails/" +
                                    props.match.params.id +
                                    "/editProductToUser/" +
                                    item.product_id._id,
                                }}
                              >
                                <button
                                  type="button"
                                  class="btn btn-primary round mr-1 mb-1 btn-sm"
                                >
                                  ویرایش
                                </button>
                              </Link>
                              <Link
                                to={{
                                  pathname:
                                    "/dashboard/userDetails/" +
                                    props.match.params.id +
                                    "/paymentsProductToUser/" +
                                    item.product_id._id,
                                }}
                              >
                                <button
                                  type="button"
                                  class="btn btn-warning round mr-1 mb-1"
                                >
                                  تراکنش ها
                                </button>
                              </Link>
                              <button
                                onClick={async () => {
                                  // await utils.showAlert(
                                  //   "در حال حذف محصول",
                                  //   "warning"
                                  // );
                                  await clear_get_user_details();
                                  const f = async () => {
                                    await delete_product_user_function({
                                      user_id: props.match.params.id,
                                      product_id: item.product_id._id,
                                    }).then(() => null);
                                    await get_user_details_function().then(
                                      () => null
                                    );
                                    await utils.showAlert(
                                      "محصول با موفقیت حذف شد",
                                      "success"
                                    );
                                    // await history.go(0);
                                  };
                                  await f();
                                }}
                                type="button"
                                class="btn btn-danger round mr-1 mb-1 btn-sm"
                              >
                                حذف
                              </button>
                            </td>
                          </>
                        ) : null}
                      </tr>
                    ))
                  }
                />
              ) : null
            ) : null}
            <div style={{ marginTop: "2rem" }}>
              <h6>پیشرفت تماشای دوره‌ها :</h6>
              {data.course_progress_data?.length ? (
                data.course_progress_data.map((course) => (
                  <div key={course.product_id} className="card card-body" style={{ marginBottom: "1rem" }}>
                    <div style={{ marginBottom: "0.8rem" }}>
                      <strong>{course.product_title}</strong>
                      <span style={{ marginRight: "1rem" }}>
                        {course.watched_videos} از {course.total_videos} ویدیو دیده شده
                      </span>
                      <span style={{ marginRight: "1rem" }}>
                        {course.completed_videos} ویدیو تکمیل شده
                      </span>
                      <span style={{ marginRight: "1rem" }}>
                        مجموع تماشا: {formatDuration(course.total_watched_seconds)}
                      </span>
                    </div>
                    <Table
                      Thead={() => (
                        <tr>
                          <th className="table--title">ویدیو</th>
                          <th className="table--title">مقدار تماشا</th>
                          <th className="table--title">پیشرفت</th>
                          <th className="table--title">آخرین تماشا</th>
                        </tr>
                      )}
                      Tbody={() => course.videos.map((video) => (
                        <tr key={video.file_id}>
                          <td>{video.file_title}</td>
                          <td>{formatDuration(video.watched_seconds)} / {video.duration_seconds ? formatDuration(video.duration_seconds) : "--:--"}</td>
                          <td>{video.progress_percent}% {video.is_completed ? "(تکمیل شده)" : ""}</td>
                          <td>{video.last_watched_at ? moment(video.last_watched_at).locale("fa").format("YYYY/MM/DD، HH:mm") : "هنوز تماشا نشده"}</td>
                        </tr>
                      ))}
                    />
                  </div>
                ))
              ) : (
                <div>برای این کاربر دوره قابل مشاهده‌ای ثبت نشده است.</div>
              )}
            </div>
          </div>
          {/* <div class="row" style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "10px" }}></div>
            <div style={{ marginBottom: "10px" }}>
              کد رهگیری : {data._ref_id}
            </div>
            <div style={{ marginBottom: "10px" }}>تصویر فیش واریزی :</div>
            <img
              src={fish_image + data.fish_img.name}
              alt="fish"
              style={{
                width: "100%",
                maxWidth: "30rem",
                objectFit: "cover",
                marginBottom: "10px",
              }}
            />
            <div style={{ marginBottom: "10px" }}>
              وضعیت تراکنش :
              {data._status === "paid"
                ? "پرداخت شده"
                : data._status === "unpaid"
                ? "پرداخت نشده"
                : data._status === "waiting"
                ? "در انتظار تایید"
                : null}
              {data._status === "waiting" ? (
                <button
                  type="button"
                  class="btn btn-success round mr-1 mb-1 btn-sm"
                  style={{ width: "fit-content" }}
                  onClick={() =>
                    verify_cart_fish_function()
                      .then(() => {
                        utils.showAlert("فیش با موفقیت تایید شد", "success");
                        history.push("/dashboard/getPayments/");
                      })
                      .catch(() =>
                        utils.showAlert(
                          "مشکلی در انجام عملیات به وجود آمد",
                          "error"
                        )
                      )
                  }
                >
                  تایید فیش
                </button>
              ) : null}
            </div>
          </div> */}
        </section>
      </div>
      {/* <!-- BEGIN: Content--> */}
    </>
  );
};

export { UserDetails };
